import React, { FC } from 'react';
import { ReactComponent as SendEmail } from '../../../assets/ExportButtons/SendEmail.svg';

export const SendEmailIcon: FC = () => <SendEmail />;
